import * as React from 'react';
import { useReducer, useEffect, useContext, createContext } from 'react';
import { isEqual } from 'lodash';

import { withNotifications } from '@components/hoc/withNotifications';
import { isLoggedIn } from '@modules/login/_loginActions';
import { getConfig, setSettings, setConfig } from './_configurationActions';
import { getGeneralSettings } from '@modules/generalSettings/_generalSettingsActions';
import { SettingsInterface, ConfigurationContextInterface, ConfigurationInterface } from './_configurationTypes';

import { configurationDefault, CONFIGURATION_TYPE } from './_configurationConstants';

import * as storage from '@inqool/uas-web-core/es/utils/storage';

const reducer = (state = configurationDefault, action) => {
  switch (action.type) {
    case CONFIGURATION_TYPE.CONFIG:
      return { config: { ...state.config, ...action.payload } };
    case CONFIGURATION_TYPE.SETTINGS:
      return { config: { ...state.config, settings: action.payload } };
    default:
      return state;
  }
};

const ConfigurationContext = createContext<ConfigurationContextInterface>(configurationDefault);

const ConfigurationProvider = ({ children, getConfigNotify, getGeneralSettingsNotify }) => {
  const [configuration, dispatchConfiguration] = useReducer<ConfigurationContextInterface, any>(
    reducer,
    configurationDefault
  );

  useEffect(() => {
    const fetchConfig = async () => {
      const configurationPromise: Promise<ConfigurationInterface | null> = getConfigNotify();
      let configurationRes, settingsRes;

      if (isLoggedIn()) {
        const settingsPromise: Promise<SettingsInterface | null> = getGeneralSettingsNotify();
        const promisses: Array<Promise<any>> = [configurationPromise, settingsPromise];

        [configurationRes, settingsRes] = await Promise.all(promisses);
        if (settingsRes) {
          setSettings({ dispatchConfiguration })(settingsRes.otherSettings);
        }
      } else {
        configurationRes = await configurationPromise;
      }

      if (configurationRes) {
        storage.remove('extensions');
        storage.safePut('extensions', configurationRes.extensions);
        setConfig({ dispatchConfiguration })(configurationRes);
      }
    };
    fetchConfig();
    return;
  }, []);

  return (
    <ConfigurationContext.Provider value={{ ...configuration, dispatchConfiguration }}>
      {isEqual(configuration, configurationDefault) ? null : children}
    </ConfigurationContext.Provider>
  );
};
export const getConfigurationContext = () => useContext(ConfigurationContext);
export const ConfigurationConsumer = ConfigurationContext.Consumer;
export default withNotifications({ getConfig, getGeneralSettings })(ConfigurationProvider);



// WEBPACK FOOTER //
// ./src/components/provider/configuration/ConfigurationProvider.tsx